import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

// eslint-disable-next-line import/prefer-default-export
export const getScheduleList = createAsyncThunk('schedule/getScheduleList',
	async ({scheduleMeta, statusMeta, venueMeta, searchMeta, pageMeta, sizeMeta, sortMeta}: ScheduleListQueryParam) => {
		const url = `/v1/closed-schedules${serializeQueryParam({
			venueId: venueMeta,
			status: statusMeta,
			search: searchMeta,
			startDate: scheduleMeta,
			endDate: scheduleMeta,
			sortBy: sortMeta ?? "createdAt",
			page: pageMeta,
			size: sizeMeta
		})}`
		const response: AxiosResponse<ScheduleState> = await instance.get(url)
		return response.data
	})
